import { call, put, takeLatest } from 'redux-saga/effects';
import types from '../actions/form.actions';
import { storeData, changeStatus } from '../actions/form.actions';
import api from "../../../../api/api";

export function* getData() {
    yield takeLatest(types.INTELLIGENCE_FORMS_GET_DATA, takeLatestData);
}

function* takeLatestData({ payload }) {

    let response = null
    switch (payload.formId) {
        case 'Esquema':
            response = yield call(api.get, `/v1/esquema`);
            if (response.status === 200) {
                yield put(storeData(payload.formId, response.data.response.data));
            }
            break;

        default:
            break;
    }
}

export function* saveData() {
    yield takeLatest(types.INTELLIGENCE_FORMS_SAVE_DATA, takeLatestSaveData);
}

function* takeLatestSaveData({ payload }) {

    let response = null
    let url = '';

    switch (payload.formId) {

        case 'Esquema':
            url = (payload.values.get("id") === '') ? '/v1/esquema' : `/v1/esquema/${payload.values.get("id")}`;
            response = yield call((payload.values.get("id") === '') ? api.post : api.put, url, payload.values, { headers: { "Content-Type": "multipart/form-data" } });
            break;

        default:
            break;
    }

    if (response.status === 200) {
        yield put(changeStatus(payload.formId, response.data));
    }
}

export function* deleteData() {
    yield takeLatest(types.INTELLIGENCE_FORMS_DELETE_DATA, takeLatestDeleteData);
}

function* takeLatestDeleteData({ payload }) {

    let url = '';
    switch (payload.formId) {

        case 'Esquema':
            url = `/v1/esquema`;
            break;

        default:
            break;
    }

    let response = yield call(api.delete, `${url}/${payload.id}`);

    if (response.status === 200) {
        yield put(changeStatus(payload.formId, response.data));
    }
}